(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var maxTilt = 6;

  document.querySelectorAll('.riwayat-tilt').forEach(function (wrapper) {
    var inner = wrapper.querySelector('.riwayat-tilt__inner');
    if (!inner) return;

    var raf = null;
    var targetX = 0;
    var targetY = 0;

    function apply() {
      raf = null;
      inner.style.setProperty('--tilt-x', targetX.toFixed(2) + 'deg');
      inner.style.setProperty('--tilt-y', targetY.toFixed(2) + 'deg');
    }

    wrapper.addEventListener(
      'pointermove',
      function (e) {
        var rect = wrapper.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        targetX = relY * -maxTilt;
        targetY = relX * maxTilt;
        if (!raf) raf = requestAnimationFrame(apply);
      },
      { passive: true }
    );

    wrapper.addEventListener('pointerleave', function () {
      targetX = 0;
      targetY = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  });
})();
